import React from "react";

const WebsiteMainPage = () => {
    return (
        <main>
            <section class="relative bg-white pt-12 md:pt-24 pb-12 overflow-hidden">
                <div class="container mx-auto px-4 md:px-6 lg:px-8 flex flex-col md:flex-row items-center">
                    <div class="md:w-1/2 text-center md:text-left mb-8 md:mb-0">
                        <h1 class="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-primary-dark leading-tight mb-4">
                            The Future of Indian Trucking is Here.
                        </h1>
                        <p class="text-lg sm:text-xl text-gray-600 mb-6">
                            Manage your fleet, track loads, and optimize routes with our powerful and easy-to-use platform.
                        </p>
                        <a href="#contact"
                            class="inline-block px-8 py-4 bg-accent text-white rounded-full font-semibold text-lg hover:bg-orange-600 transition duration-300 shadow-lg">
                            Start Your Free Trial
                        </a>
                    </div>
                    <div class="md:w-1/2">
                        <img src="https://img.freepik.com/free-photo/truck-logistics-operations-dusk_23-2151468850.jpg?ga=GA1.1.234554163.1758561986&semt=ais_hybrid&w=740&q=80"
                            alt="Indian truck on highway"
                            class="w-full rounded-xl shadow-xl transform hover:scale-105 transition-transform duration-500" />
                    </div>
                </div>
            </section>

            <section id="features" class="py-16 bg-secondary-light">
                <div class="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <h2 class="text-3xl sm:text-4xl font-bold text-primary-dark mb-4">Streamline Your Trucking Operations
                    </h2>
                    <p class="text-lg text-gray-600 mb-12 max-w-2xl mx-auto">
                        From the bustling highways to the narrow city lanes, we have you covered with features designed for
                        India.
                    </p>
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        <div class="bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-shadow duration-300">
                            <div
                                class="bg-primary-light text-white w-16 h-16 flex items-center justify-center rounded-full mx-auto mb-4">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24"
                                    stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M13 10V3L4 14h7v7l9-11h-7z" />
                                </svg>
                            </div>
                            <h3 class="text-xl font-bold text-primary-dark mb-2">Real-Time Tracking</h3>
                            <p class="text-gray-600">
                                Know the exact location of your trucks and cargo at any moment, ensuring timely delivery and
                                security.
                            </p>
                        </div>
                        <div class="bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-shadow duration-300">
                            <div
                                class="bg-primary-light text-white w-16 h-16 flex items-center justify-center rounded-full mx-auto mb-4">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24"
                                    stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M12 8c1.657 0 3 .895 3 2s-1.343 2-3 2-3-.895-3-2 1.343-2 3-2zM9 14h6M4 21h16a2 2 0 002-2V7a2 2 0 00-2-2H4a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                </svg>
                            </div>
                            <h3 class="text-xl font-bold text-primary-dark mb-2">Load Matching</h3>
                            <p class="text-gray-600">
                                Connect with available loads instantly, reducing empty miles and maximizing your revenue
                                efficiently.
                            </p>
                        </div>
                        <div class="bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-shadow duration-300">
                            <div
                                class="bg-primary-light text-white w-16 h-16 flex items-center justify-center rounded-full mx-auto mb-4">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24"
                                    stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9h2m-2 4h2m2-4h2m-2 4h2" />
                                </svg>
                            </div>
                            <h3 class="text-xl font-bold text-primary-dark mb-2">Paperless Billing</h3>
                            <p class="text-gray-600">
                                Go digital with your invoices and payments, making transactions faster and more transparent
                                for everyone.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section id="services" class="py-16 bg-white">
                <div class="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <h2 class="text-3xl sm:text-4xl font-bold text-primary-dark mb-4">Our Core Services</h2>
                    <p class="text-lg text-gray-600 mb-12 max-w-2xl mx-auto">
                        We provide a comprehensive suite of tools to manage every aspect of your trucking business.
                    </p>
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-12 items-center">
                        <div class="md:text-left space-y-8">
                            <div class="flex items-start space-x-4">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10 text-accent flex-shrink-0"
                                    fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M9 20l-5.63-5.63a9 9 0 1115.63 0L15 20m-3-12h.01M9 16.5a1.5 1.5 0 01-1.5-1.5V11a1.5 1.5 0 011.5-1.5h6a1.5 1.5 0 011.5 1.5v4a1.5 1.5 0 01-1.5 1.5h-6z" />
                                </svg>
                                <div>
                                    <h3 class="text-xl font-semibold text-primary-dark">Route Optimization</h3>
                                    <p class="text-gray-600 mt-1">Our intelligent system finds the fastest and most
                                        fuel-efficient routes for your drivers, saving you time and money on every trip.</p>
                                </div>
                            </div>
                            <div class="flex items-start space-x-4">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10 text-accent flex-shrink-0"
                                    fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                                </svg>
                                <div>
                                    <h3 class="text-xl font-semibold text-primary-dark">Fuel & Expense Management</h3>
                                    <p class="text-gray-600 mt-1">Easily log and track all your fuel and operational
                                        expenses to gain insights into your fleet's profitability.</p>
                                </div>
                            </div>
                            <div class="flex items-start space-x-4">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10 text-accent flex-shrink-0"
                                    fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                <div>
                                    <h3 class="text-xl font-semibold text-primary-dark">Maintenance Reminders</h3>
                                    <p class="text-gray-600 mt-1">Receive automated alerts for vehicle maintenance, ensuring
                                        your trucks are always in top condition and preventing costly breakdowns.</p>
                                </div>
                            </div>
                        </div>
                        <div>
                            <img src="https://img.freepik.com/premium-photo/transportation-timber-wooden-piles-logs-cargo-wood-factories-wooden-furniture-production_909686-149.jpg?ga=GA1.1.234554163.1758561986&semt=ais_hybrid&w=740&q=80"
                                alt="Route optimization map" class="rounded-xl shadow-xl" />
                        </div>
                    </div>
                </div>
            </section>

            <section id="why-choose-us" class="py-16 bg-secondary-light">
                <div class="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <h2 class="text-3xl sm:text-4xl font-bold text-primary-dark mb-12">Why Choose Desi Hauler?</h2>
                    <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
                        <div class="bg-white p-8 rounded-xl shadow-lg flex flex-col items-center text-center">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-16 w-16 text-primary-light mb-4" fill="none"
                                viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944c-3.197 0-6.216.9-8.706 2.536M2.536 8.706a11.955 11.955 0 010 6.588m8.706 2.536a11.955 11.955 0 01-6.588 0m6.588-2.536a11.955 11.955 0 010-6.588m-2.536 8.706a11.955 11.955 0 016.588 0" />
                            </svg>
                            <h3 class="text-xl font-bold text-primary-dark mb-2">Unmatched Reliability</h3>
                            <p class="text-gray-600">
                                Our network of verified drivers and transparent processes ensures your goods arrive safely
                                and on time.
                            </p>
                        </div>
                        <div class="bg-white p-8 rounded-xl shadow-lg flex flex-col items-center text-center">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-16 w-16 text-primary-light mb-4" fill="none"
                                viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                            </svg>
                            <h3 class="text-xl font-bold text-primary-dark mb-2">Simplified Platform</h3>
                            <p class="text-gray-600">
                                Our user-friendly app is designed for everyone, from experienced fleet managers to
                                first-time users.
                            </p>
                        </div>
                        <div class="bg-white p-8 rounded-xl shadow-lg flex flex-col items-center text-center">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-16 w-16 text-primary-light mb-4" fill="none"
                                viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M9 7h6m0 10v.01M12 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2m0 0a2 2 0 11-4 0m4 0a2 2 0 10-4 0" />
                            </svg>
                            <h3 class="text-xl font-bold text-primary-dark mb-2">Transparent Pricing</h3>
                            <p class="text-gray-600">
                                Say goodbye to hidden fees. Our pricing is clear and competitive, ensuring you get the best
                                value.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section id="our-fleet" class="py-16 bg-white">
                <div class="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <h2 class="text-3xl sm:text-4xl font-bold text-primary-dark mb-4">Our Fleet</h2>
                    <p class="text-lg text-gray-600 mb-12 max-w-2xl mx-auto">
                        We manage a diverse fleet of trucks to handle all types of cargo, from small packages to heavy
                        machinery.
                    </p>
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        <div class="rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-300">
                            <img src="https://img.freepik.com/premium-photo/truck-transporting-steel-product-cargo_909686-959.jpg?ga=GA1.1.234554163.1758561986&semt=ais_hybrid&w=740&q=80"
                                alt="Small truck" class="w-full h-64 object-cover" />
                            <div class="p-6">
                                <h3 class="text-xl font-bold text-primary-dark mb-2">Small & Mid-Sized Trucks</h3>
                                <p class="text-gray-600">Ideal for urban deliveries and smaller loads.</p>
                            </div>
                        </div>
                        <div class="rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-300">
                            <img src="https://img.freepik.com/premium-photo/stack-hay-semi-truck-street_1048944-27001072.jpg?ga=GA1.1.234554163.1758561986&semt=ais_hybrid&w=740&q=80"
                                alt="Large truck" class="w-full h-64 object-cover" />
                            <div class="p-6">
                                <h3 class="text-xl font-bold text-primary-dark mb-2">Large & Heavy Haulers</h3>
                                <p class="text-gray-600">Perfect for interstate transportation of heavy goods.</p>
                            </div>
                        </div>
                        <div class="rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow duration-300">
                            <img src="https://img.freepik.com/premium-photo/truck-highway-road-warsaw-poland-lorry-transport-delivering-some-freight-cargo_250132-25775.jpg?ga=GA1.1.234554163.1758561986&semt=ais_hybrid&w=740&q=80"
                                alt="Specialized trucks" class="w-full h-64 object-cover" />
                            <div class="p-6">
                                <h3 class="text-xl font-bold text-primary-dark mb-2">Specialized Vehicles</h3>
                                <p class="text-gray-600">Equipped for handling temperature-sensitive and delicate cargo.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="about" class="py-16 bg-secondary-light">
                <div class="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <h2 class="text-3xl sm:text-4xl font-bold text-primary-dark mb-4">Our Commitment Powering India's
                        Backbone</h2>
                    <div class="flex flex-col md:flex-row items-center justify-between mt-8 md:space-x-8">
                        <div class="md:w-1/2 mb-8 md:mb-0">
                            <img src="https://img.freepik.com/premium-photo/loading-cargo-containers-onto-container-ships-international-sea-port-using-cranes-freight_1007204-4258.jpg?ga=GA1.1.234554163.1758561986&semt=ais_hybrid&w=740&q=80"
                                alt="Indian logistics hub"
                                class="w-full rounded-xl shadow-xl transform hover:scale-105 transition-transform duration-500" />
                        </div>
                        <div class="md:w-1/2 text-left">
                            <p class="text-lg text-gray-600 mb-4">
                                At Desi Hauler, we understand that trucks are the lifeblood of India's economy. Our mission
                                is to empower fleet owners and drivers with cutting-edge technology that simplifies
                                logistics, improves efficiency, and boosts profitability. We're a team of innovators with
                                deep roots in the Indian logistics landscape, committed to solving real-world challenges
                                with smart, accessible solutions.
                            </p>
                            <p class="text-lg text-gray-600">
                                We believe in a future where technology and tradition go hand-in-hand, making every journey
                                smoother and more rewarding for our partners. Our platform is built with the unique needs of
                                the Indian market in mind, from local dialects to diverse road conditions.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section id="team" class="py-16 bg-white">
                <div class="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <h2 class="text-3xl sm:text-4xl font-bold text-primary-dark mb-4">Meet the Team</h2>
                    <p class="text-lg text-gray-600 mb-12 max-w-2xl mx-auto">
                        We are a passionate team dedicated to making a difference in the Indian logistics industry.
                    </p>
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        <div class="bg-secondary-light p-6 rounded-xl shadow-lg">
                            <img src="https://img.freepik.com/free-photo/smiling-young-male-professional-standing-with-arms-crossed-while-making-eye-contact-against-isolated-background_662251-838.jpg?ga=GA1.1.234554163.1758561986&semt=ais_incoming&w=740&q=80"
                                alt="Co-Founder 1" class="w-32 h-32 rounded-full mx-auto mb-4 object-cover" />
                            <h3 class="text-xl font-bold text-primary-dark">Anil Kumar</h3>
                            <p class="text-primary-light font-medium">Co-Founder & CEO</p>
                            <p class="text-gray-600 mt-2">A seasoned logistics expert with over 20 years of experience in
                                the industry.</p>
                        </div>
                        <div class="bg-secondary-light p-6 rounded-xl shadow-lg">
                            <img src="https://img.freepik.com/free-photo/portrait-young-smiling-businessman_1163-3880.jpg?ga=GA1.1.234554163.1758561986&semt=ais_incoming&w=740&q=80"
                                alt="Co-Founder 2" class="w-32 h-32 rounded-full mx-auto mb-4 object-cover" />
                            <h3 class="text-xl font-bold text-primary-dark">Priya Sharma</h3>
                            <p class="text-primary-light font-medium">Co-Founder & CTO</p>
                            <p class="text-gray-600 mt-2">A technology visionary focused on building scalable and
                                user-friendly solutions.</p>
                        </div>
                        <div class="bg-secondary-light p-6 rounded-xl shadow-lg">
                            <img src="https://img.freepik.com/free-photo/portrait-positive-confident-businessman_1262-17122.jpg?ga=GA1.1.234554163.1758561986&semt=ais_incoming&w=740&q=80"
                                alt="Team member 3" class="w-32 h-32 rounded-full mx-auto mb-4 object-cover" />
                            <h3 class="text-xl font-bold text-primary-dark">Rajeev Gupta</h3>
                            <p class="text-primary-light font-medium">Head of Operations</p>
                            <p class="text-gray-600 mt-2">Dedicated to ensuring smooth daily operations and top-notch
                                customer support.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section class="py-16 bg-primary-dark text-white">
                <div class="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
                        <div class="p-4">
                            <div class="text-4xl lg:text-5xl font-extrabold mb-2">5,000+</div>
                            <div class="text-lg font-medium">Trucks Registered</div>
                        </div>
                        <div class="p-4">
                            <div class="text-4xl lg:text-5xl font-extrabold mb-2">1 Lakh+</div>
                            <div class="text-lg font-medium">Loads Delivered</div>
                        </div>
                        <div class="p-4">
                            <div class="text-4xl lg:text-5xl font-extrabold mb-2">98%</div>
                            <div class="text-lg font-medium">On-Time Deliveries</div>
                        </div>
                        <div class="p-4">
                            <div class="text-4xl lg:text-5xl font-extrabold mb-2">24/7</div>
                            <div class="text-lg font-medium">Support Available</div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="how-it-works" class="py-16 bg-secondary-light">
                <div class="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <h2 class="text-3xl sm:text-4xl font-bold text-primary-dark mb-12">How It Works</h2>
                    <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
                        <div class="flex flex-col items-center bg-white p-8 rounded-xl shadow-lg">
                            <div class="text-5xl font-bold text-primary-light mb-4">1</div>
                            <h3 class="text-xl font-bold text-primary-dark mb-2">Create Your Profile</h3>
                            <p class="text-gray-600">
                                Quick and easy registration. Set up your fleet and driver details in minutes.
                            </p>
                        </div>
                        <div class="flex flex-col items-center bg-white p-8 rounded-xl shadow-lg">
                            <div class="text-5xl font-bold text-primary-light mb-4">2</div>
                            <h3 class="text-xl font-bold text-primary-dark mb-2">Find & Book Loads</h3>
                            <p class="text-gray-600">
                                Browse thousands of available loads, filter by route, and book instantly.
                            </p>
                        </div>
                        <div class="flex flex-col items-center bg-white p-8 rounded-xl shadow-lg">
                            <div class="text-5xl font-bold text-primary-light mb-4">3</div>
                            <h3 class="text-xl font-bold text-primary-dark mb-2">Manage & Get Paid</h3>
                            <p class="text-gray-600">
                                Track your shipment, manage billing, and receive secure payments all in one place.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section id="testimonials" class="py-16 bg-white">
                <div class="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <h2 class="text-3xl sm:text-4xl font-bold text-primary-dark mb-12">What Our Clients Say</h2>
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        <div class="bg-secondary-light p-6 rounded-xl shadow-lg">
                            <p class="text-gray-600 italic mb-4">
                                "Desi Hauler has completely transformed how we manage our fleet. The real-time tracking is a
                                lifesaver and helps us keep our clients happy."
                            </p>
                            <div class="text-gray-800 font-semibold">- Rahul Sharma, Fleet Owner</div>
                        </div>
                        <div class="bg-secondary-light p-6 rounded-xl shadow-lg">
                            <p class="text-gray-600 italic mb-4">
                                "Finding a return load used to be a challenge. With this platform, I find new work before my
                                current trip is even finished!"
                            </p>
                            <div class="text-gray-800 font-semibold">- Preet Singh, Truck Driver</div>
                        </div>
                        <div class="bg-secondary-light p-6 rounded-xl shadow-lg">
                            <p class="text-gray-600 italic mb-4">
                                "The customer support is fantastic, and the system is so simple to use. My business has
                                never been more efficient."
                            </p>
                            <div class="text-gray-800 font-semibold">- Fatima Khan, Logistics Manager</div>
                        </div>
                        <div class="bg-secondary-light p-6 rounded-xl shadow-lg">
                            <p class="text-gray-600 italic mb-4">
                                "The customer support is fantastic, and the system is so simple to use. My business has
                                never been more efficient."
                            </p>
                            <div class="text-gray-800 font-semibold">- Fatima Khan, Logistics Manager</div>
                        </div>
                        <div class="bg-secondary-light p-6 rounded-xl shadow-lg">
                            <p class="text-gray-600 italic mb-4">
                                "The customer support is fantastic, and the system is so simple to use. My business has
                                never been more efficient."
                            </p>
                            <div class="text-gray-800 font-semibold">- Fatima Khan, Logistics Manager</div>
                        </div>
                        <div class="bg-secondary-light p-6 rounded-xl shadow-lg">
                            <p class="text-gray-600 italic mb-4">
                                "The customer support is fantastic, and the system is so simple to use. My business has
                                never been more efficient."
                            </p>
                            <div class="text-gray-800 font-semibold">- Fatima Khan, Logistics Manager</div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="contact" class="py-16 bg-primary-light text-white text-center">
                <div class="container mx-auto px-4 sm:px-6 lg:px-8">
                    <h2 class="text-3xl sm:text-4xl font-bold mb-4">Ready to Get Rolling?</h2>
                    <p class="text-lg mb-8 max-w-2xl mx-auto">
                        Join the thousands of truck owners and drivers who are revolutionizing their business with Desi
                        Hauler.
                    </p>
                    <form class="flex flex-col sm:flex-row justify-center items-center gap-4">
                        <input type="email" placeholder="Enter your email"
                            class="px-6 py-3 rounded-full text-gray-800 w-full sm:w-auto focus:outline-none focus:ring-2 focus:ring-accent" />
                        <button type="submit"
                            class="px-8 py-3 bg-accent text-white rounded-full font-semibold hover:bg-orange-600 transition duration-300 w-full sm:w-auto">
                            Sign Up Today
                        </button>
                    </form>
                </div>
            </section>
        </main>
    );
}

export default WebsiteMainPage;